function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M61.6783 78.0086C86.4747 78.0086 106.576 60.5458 106.576 39.0043C106.576 17.4628 86.4747 0 61.6783 0C36.882 0 16.7805 17.4628 16.7805 39.0043C16.7805 60.5458 36.882 78.0086 61.6783 78.0086Z",
  fill: "#F2F2F2"
}), React.createElement("path", {
  d: "M0 9.36511C0 23.5564 10.2481 35.0399 22.9128 35.0399L0 9.36511Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M22.9128 35.0399C22.9128 20.6891 34.3491 9.07666 48.4822 9.07666L22.9128 35.0399Z",
  fill: "#E9663A"
}), React.createElement("path", {
  d: "M8.30176 10.6516C8.30176 24.1319 14.8368 35.0399 22.9128 35.0399L8.30176 10.6516Z",
  fill: "#E9663A"
}), React.createElement("path", {
  d: "M22.9128 35.0399C22.9128 16.7028 36.1314 1.86462 52.467 1.86462L22.9128 35.0399Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M18.0925 35.2209C18.0925 35.2209 21.3419 35.134 22.3212 34.5282C23.3005 33.9224 27.3196 33.199 27.5626 34.1706C27.8055 35.1421 32.4458 39.0027 28.7773 39.0285C25.1087 39.0542 20.2531 38.532 19.2757 38.0148C18.2983 37.4976 18.0925 35.2209 18.0925 35.2209Z",
  fill: "#A8A8A8"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M28.8427 38.6902C25.1742 38.7159 20.3186 38.1938 19.3412 37.6765C18.5969 37.2826 18.3003 35.8692 18.201 35.2172C18.1323 35.2197 18.0925 35.2208 18.0925 35.2208C18.0925 35.2208 18.2983 37.4975 19.2757 38.0147C20.2532 38.5319 25.1087 39.0541 28.7773 39.0284C29.8362 39.0209 30.202 38.6936 30.182 38.2089C30.0348 38.5018 29.6309 38.6846 28.8427 38.6902Z",
  fill: "black"
}), React.createElement("path", {
  d: "M41.8644 82.3924C63.6339 82.3924 81.2817 80.3067 81.2817 77.7339C81.2817 75.161 63.6339 73.0753 41.8644 73.0753C20.0948 73.0753 2.44702 75.161 2.44702 77.7339C2.44702 80.3067 20.0948 82.3924 41.8644 82.3924Z",
  fill: "#3F3D56"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M41.8642 81.6451C60.1413 81.6451 74.9579 79.894 74.9579 77.7339C74.9579 75.5738 60.1413 73.8228 41.8642 73.8228C23.5871 73.8228 8.77051 75.5738 8.77051 77.7339C8.77051 79.894 23.5871 81.6451 41.8642 81.6451Z",
  fill: "black"
}), React.createElement("path", {
  d: "M176.347 128C209.292 128 236 124.844 236 120.95C236 117.056 209.292 113.9 176.347 113.9C143.402 113.9 116.694 117.056 116.694 120.95C116.694 124.844 143.402 128 176.347 128Z",
  fill: "#3F3D56"
}), React.createElement("path", {
  d: "M65.4726 122.438C85.2631 122.438 101.307 120.542 101.307 118.203C101.307 115.864 85.2631 113.968 65.4726 113.968C45.6821 113.968 29.6387 115.864 29.6387 118.203C29.6387 120.542 45.6821 122.438 65.4726 122.438Z",
  fill: "#3F3D56"
}), React.createElement("path", {
  d: "M97.5125 114.632C116.483 118.844 152.95 109.139 156.955 98.1517",
  stroke: "#2F2E41",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M65.2617 47.4277C65.2617 47.4277 92.6642 40.8354 94.3505 62.0772C96.0368 83.319 71.7961 89.3619 90.7671 93.5737",
  stroke: "#2F2E41",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M38.7874 98.3867C38.7874 98.3867 47.0233 96.4053 47.5301 102.79C48.037 109.174 40.7513 110.99 46.4531 112.256",
  stroke: "#2F2E41",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M164.141 103.14L162.481 112.35C162.481 112.35 154.306 116.123 160.054 116.233C165.802 116.344 192.881 116.233 192.881 116.233C192.881 116.233 198.118 116.233 189.815 112.239L188.155 102.585L164.141 103.14Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M158.898 116.134C160.203 115.124 162.481 114.073 162.481 114.073L164.142 104.863L188.155 104.883L189.815 113.962C191.751 114.894 192.951 115.608 193.653 116.156C194.719 115.944 195.884 115.159 189.815 112.239L188.155 102.585L164.142 103.14L162.481 112.35C162.481 112.35 155.612 115.52 158.898 116.134Z",
  fill: "black"
}), React.createElement("path", {
  d: "M226.31 38.9473H125.731C123.63 38.9473 121.927 40.4267 121.927 42.2518V101.111C121.927 102.936 123.63 104.416 125.731 104.416H226.31C228.411 104.416 230.114 102.936 230.114 101.111V42.2518C230.114 40.4267 228.411 38.9473 226.31 38.9473Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M226.474 42.4426H125.567V91.4886H226.474V42.4426Z",
  fill: "#3F3D56"
}), React.createElement("path", {
  d: "M176.02 41.444C176.373 41.444 176.659 41.1956 176.659 40.8892C176.659 40.5828 176.373 40.3344 176.02 40.3344C175.668 40.3344 175.382 40.5828 175.382 40.8892C175.382 41.1956 175.668 41.444 176.02 41.444Z",
  fill: "#F2F2F2"
}), React.createElement("path", {
  d: "M230.114 95.3723V101.111C230.114 101.545 230.016 101.975 229.825 102.376C229.634 102.777 229.354 103.141 229 103.448C228.647 103.755 228.228 103.998 227.766 104.164C227.305 104.33 226.81 104.416 226.31 104.416H125.731C125.231 104.416 124.736 104.33 124.275 104.164C123.813 103.998 123.394 103.755 123.041 103.448C122.687 103.141 122.407 102.777 122.216 102.376C122.025 101.975 121.927 101.545 121.927 101.111V95.3723H230.114Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M204.249 122.226V123.335H135.53V122.448L135.624 122.226L137.318 118.231H202.844L204.249 122.226Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M230.694 121.139C230.569 121.604 230.096 122.095 229.028 122.558C225.196 124.223 217.405 122.114 217.405 122.114C217.405 122.114 211.402 121.227 211.402 118.897C211.57 118.796 211.746 118.705 211.928 118.625C213.539 117.884 218.881 116.057 228.352 118.702C229.05 118.892 229.673 119.247 230.152 119.727C230.536 120.117 230.837 120.612 230.694 121.139Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M230.694 121.139C226.004 122.7 221.823 122.817 217.533 120.228C215.369 118.923 213.403 118.6 211.928 118.625C213.539 117.884 218.881 116.057 228.352 118.702C229.05 118.892 229.673 119.247 230.152 119.727C230.536 120.117 230.837 120.612 230.694 121.139Z",
  fill: "black"
}), React.createElement("path", {
  d: "M224.813 120.228C225.73 120.228 226.474 120.029 226.474 119.784C226.474 119.539 225.73 119.34 224.813 119.34C223.896 119.34 223.153 119.539 223.153 119.784C223.153 120.029 223.896 120.228 224.813 120.228Z",
  fill: "#F2F2F2"
}), React.createElement("path", {
  d: "M176.02 102.03C177.361 102.03 178.447 101.086 178.447 99.9218C178.447 98.7574 177.361 97.8135 176.02 97.8135C174.68 97.8135 173.594 98.7574 173.594 99.9218C173.594 101.086 174.68 102.03 176.02 102.03Z",
  fill: "#F2F2F2"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M204.249 122.225V123.335H135.53V122.447L135.624 122.225H204.249Z",
  fill: "black"
}), React.createElement("path", {
  d: "M66.7372 29.1158H22.8933V73.4306H66.7372V29.1158Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M71.164 24.7211H18.467V40.4693H71.164V24.7211Z",
  fill: "#3F3D56"
}), React.createElement("path", {
  d: "M71.164 43.3992H18.467V59.1474H71.164V43.3992Z",
  fill: "#3F3D56"
}), React.createElement("path", {
  d: "M71.164 62.0773H18.467V77.8255H71.164V62.0773Z",
  fill: "#3F3D56"
}), React.createElement("path", {
  opacity: 0.4,
  d: "M60.6246 27.4678H57.252V30.3977H60.6246V27.4678Z",
  fill: "#E9663A"
}), React.createElement("path", {
  opacity: 0.8,
  d: "M65.4727 27.4678H62.1001V30.3977H65.4727V27.4678Z",
  fill: "#E9663A"
}), React.createElement("path", {
  d: "M70.3208 27.4678H66.9482V30.3977H70.3208V27.4678Z",
  fill: "#E9663A"
}), React.createElement("path", {
  opacity: 0.4,
  d: "M60.6246 45.9628H57.252V48.8927H60.6246V45.9628Z",
  fill: "#E9663A"
}), React.createElement("path", {
  opacity: 0.8,
  d: "M65.4727 45.9628H62.1001V48.8927H65.4727V45.9628Z",
  fill: "#E9663A"
}), React.createElement("path", {
  d: "M70.3208 45.9628H66.9482V48.8927H70.3208V45.9628Z",
  fill: "#E9663A"
}), React.createElement("path", {
  opacity: 0.4,
  d: "M60.6246 64.4578H57.252V67.3877H60.6246V64.4578Z",
  fill: "#E9663A"
}), React.createElement("path", {
  opacity: 0.8,
  d: "M65.4727 64.4578H62.1001V67.3877H65.4727V64.4578Z",
  fill: "#E9663A"
}), React.createElement("path", {
  d: "M70.3208 64.4578H66.9482V67.3877H70.3208V64.4578Z",
  fill: "#E9663A"
}), React.createElement("path", {
  d: "M66.7374 112.984C75.9342 112.984 83.3897 106.507 83.3897 98.5179C83.3897 90.5283 75.9342 84.0515 66.7374 84.0515C57.5407 84.0515 50.0852 90.5283 50.0852 98.5179C50.0852 106.507 57.5407 112.984 66.7374 112.984Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M64.2078 109.871H59.1489V117.745H64.2078V109.871Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M74.3258 109.871H69.2668V117.745H74.3258V109.871Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M63.3647 119.21C65.693 119.21 67.5804 118.595 67.5804 117.837C67.5804 117.078 65.693 116.464 63.3647 116.464C61.0364 116.464 59.1489 117.078 59.1489 117.837C59.1489 118.595 61.0364 119.21 63.3647 119.21Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M73.4826 119.027C75.8109 119.027 77.6984 118.412 77.6984 117.654C77.6984 116.895 75.8109 116.28 73.4826 116.28C71.1543 116.28 69.2668 116.895 69.2668 117.654C69.2668 118.412 71.1543 119.027 73.4826 119.027Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M67.1588 99.7998C70.302 99.7998 72.8501 97.5862 72.8501 94.8556C72.8501 92.125 70.302 89.9114 67.1588 89.9114C64.0156 89.9114 61.4675 92.125 61.4675 94.8556C61.4675 97.5862 64.0156 99.7998 67.1588 99.7998Z",
  fill: "white"
}), React.createElement("path", {
  d: "M67.1588 96.5035C68.2066 96.5035 69.0559 95.7657 69.0559 94.8555C69.0559 93.9453 68.2066 93.2074 67.1588 93.2074C66.1111 93.2074 65.2617 93.9453 65.2617 94.8555C65.2617 95.7657 66.1111 96.5035 67.1588 96.5035Z",
  fill: "#3F3D56"
}), React.createElement("path", {
  d: "M50.5841 85.0646C49.2395 79.8333 53.5376 74.5473 60.1842 73.258C66.8308 71.9687 73.3089 75.1643 74.6535 80.3956C75.9981 85.6268 71.5932 87.5562 64.9466 88.8455C58.3 90.1348 51.9287 90.2958 50.5841 85.0646Z",
  fill: "#E9663A"
}), React.createElement("path", {
  d: "M82.3555 95.6326C86.583 94.0607 89.5495 91.8518 88.9815 90.6989C88.4135 89.546 84.526 89.8856 80.2985 91.4575C76.0711 93.0293 73.1045 95.2382 73.6725 96.3911C74.2405 97.5441 78.128 97.2044 82.3555 95.6326Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M51.159 105.338C55.3864 103.766 58.353 101.557 57.785 100.404C57.2169 99.2513 53.3294 99.5909 49.102 101.163C44.8745 102.735 41.908 104.944 42.476 106.096C43.044 107.249 46.9315 106.91 51.159 105.338Z",
  fill: "#2F2E41"
}), React.createElement("path", {
  d: "M76.4336 102.73C76.4336 104.146 72.2371 106.941 67.5805 106.941C62.9239 106.941 58.5166 104.329 58.5166 102.913C58.5166 101.497 62.9239 101.814 67.5805 101.814C72.2371 101.814 76.4336 101.314 76.4336 102.73Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 236,
  height: 128,
  fill: "white"
})));

var SvgServerError = function SvgServerError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 236,
    height: 128,
    viewBox: "0 0 236 128",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgServerError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/serverError.2e8c3b96.svg";
export { ForwardRef as ReactComponent };